<div class="layout-topbar">
    <a class="layout-topbar-logo" routerLink="">
        <img src="assets/layout/images/{{layoutService.config().colorScheme === 'light' ? 'logo-dark' : 'logo-white'}}.svg"
            alt="logo">
        <span>REPORTER</span>
    </a>

    <button #menubutton class="p-link layout-menu-button layout-topbar-button" (click)="layoutService.onMenuToggle()">
        <i class="pi pi-bars"></i>
    </button>

    <button #topbarmenubutton class="p-link layout-topbar-menu-button layout-topbar-button"
        (click)="layoutService.showProfileSidebar()">
        <i class="pi pi-ellipsis-v"></i>
    </button>

    <div #topbarmenu class="layout-topbar-menu"
        [ngClass]="{'layout-topbar-menu-mobile-active': layoutService.state.profileSidebarVisible}">
        <button *ngIf="lightMode" class="p-link layout-topbar-button" (click)="swapTheme(false)">
            <i class="pi pi-moon"></i>
            <span>Toggle dark mode</span>
        </button>
        <button *ngIf="!lightMode" class="p-link layout-topbar-button" (click)="swapTheme(true)">
            <i class="pi pi-sun"></i>
            <span>Toggle light mode</span>
        </button>

        <button class="p-link layout-topbar-button" (click)="onExitClick()" pTooltip="Esci" tooltipPosition="bottom">
            <i class="pi pi-sign-out"></i>
            <span>Log out</span>
        </button>
    </div>
</div>